[
  {
    "code": "TJ-DU",
    "name": "Dushanbe"
  },
  {
    "code": "TJ-KT",
    "name": "Khatlon"
  },
  {
    "code": "TJ-GB",
    "name": "Kŭhistoni Badakhshon"
  },
  {
    "code": "TJ-SU",
    "name": "Sughd"
  }
]